import { useEffect, useState } from 'react';
import classnames from 'classnames';

import { Svg } from '@components/svg/Svg';

import { getErrorMessage } from '@common/utils/errorMessage';
import { handleError } from '@common/utils/handleError';

import styles from './copy-link-button.module.scss';

type CopyLinkButtonProps = {
	className?: string;
};

export const CopyLinkButton = ({ className }: CopyLinkButtonProps) => {
	const [isCopied, setIsCopied] = useState(false);

	useEffect(() => {
		if (!isCopied) {
			return;
		}

		const timeoutID = setTimeout(() => {
			setIsCopied(false);
		}, 3000);

		return () => {
			clearTimeout(timeoutID);
		};
	}, [isCopied]);

	const handleClick = async () => {
		try {
			const { origin, pathname } = window.location;

			await navigator.clipboard.writeText(origin + pathname);

			setIsCopied(true);
		} catch (error) {
			handleError(getErrorMessage(error));
		}
	};

	return (
		<button
			className={classnames(className, styles.button, 'badge badge--rounded')}
			onClick={handleClick}
			type="button"
		>
			<Svg aria-hidden="true" className={styles.icon} id="link-icon" />
			{isCopied ? 'Link copied' : 'Copy link'}
		</button>
	);
};
